import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { timer, Subscription } from 'rxjs';

@Component({
  selector: 'v2m-image-ticker',
  templateUrl: './image-ticker.component.html',
  styleUrls: ['./image-ticker.component.scss']
})
export class ImageTickerComponent implements OnInit, OnDestroy {
  @Input() title = 'Referenzen';
  @Input() images = [];
  timerSubscription: Subscription;
  blocks = [];

  constructor() {}

  ngOnInit(): void {
    for (let i = 0; i < this.images.length; i++) {
      this.blocks.push({
        position: i + 1,
        image: this.images[i],
        content: 'Referenz'
      });
    }

    const source = timer(4000, 4000);
    this.timerSubscription = source.subscribe(val => {
      for (const block of this.blocks) {
        block.position =
          block.position < 2 ? this.blocks.length : block.position - 1;
      }
    });
  }
  ngOnDestroy(): void {
    this.timerSubscription.unsubscribe();
  }
}
